/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useState } from 'react';
import { userSelectors } from '../../../../../app/resource/user/user.selectors';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { Tooltip } from '../../../../common/Tooltip';
import { IUserAvatarsProps } from './types';
import { CircularAvatar } from '../../../common/CustomAvatar';

export const UserAvatars: FunctionComponent<IUserAvatarsProps> = ({ userIds }) => {
  const users = useSelectWithParams(userSelectors.selectResourcesById, userIds);
  const overSize = users.length > 7 ? true : false;
  const partUsers = users.slice(0, 7);
  const countLeft = users.length - partUsers.length;
  const [toggle, setToggle] = useState(false);

  return (
    <>
      <div className="flex aic h100" style={{ flexWrap: 'wrap', width: '280px' }}>
        {users && toggle
          ? users.map(
              (user) =>
                user && (
                  <Tooltip
                    content={`${user.firstName} ${user.lastName}`}
                    direction="top"
                    bgColor="#13ac92"
                    textColor="white"
                    key={user.id}
                  >
                    <a key={user.id} className="small-avatar mr-1">
                      <CircularAvatar
                        src={user.image}
                        title={`${user.firstName} ${user.lastName}`}
                        styles={{ verticalAlign: 'baseline' }}
                      />
                    </a>
                  </Tooltip>
                ),
            )
          : partUsers.map(
              (user) =>
                user && (
                  <Tooltip
                    content={`${user.firstName} ${user.lastName}`}
                    direction="top"
                    bgColor="#13ac92"
                    textColor="white"
                    key={user.id}
                  >
                    <a key={user.id} className="small-avatar mr-1">
                      <CircularAvatar
                        src={user.image}
                        title={`${user.firstName} ${user.lastName}`}
                        styles={{ verticalAlign: 'baseline' }}
                      />
                    </a>
                  </Tooltip>
                ),
            )}
      </div>
      {overSize && (
        <div
          className="small-avatar mr-1 gray-bg"
          style={{
            textAlign: 'center',
            display: 'flex',
            minWidth: '40px',
            minHeight: '40px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={(e: React.MouseEvent<HTMLElement>) => {
            setToggle(!toggle);
            e.stopPropagation();
          }}
        >
          {!toggle && <span style={{ paddingLeft: '4px' }}>{`+${countLeft}`}</span>}
          <i className="icon-down-dir" style={toggle ? { transform: 'rotate(180deg)', display: 'block' } : {}} />
        </div>
      )}
    </>
  );
};
